import styled from 'styled-components'

export const GiftCardCodeWrapper = styled.div`
  display: flex;
  gap: var(--space-200);
  align-items: center;
`
